import React from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import { UTLabel } from '@widergy/energy-ui';

import styles from './styles';

const FieldDetailFormatter = ({ field, isLastElement }) => (
  <div style={isLastElement ? styles.lastField : styles.field}>
    <UTLabel style={styles.element}>{field.value}</UTLabel>
  </div>
);

FieldDetailFormatter.propTypes = {
  field: PropTypes.shape({
    value: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }),
  isLastElement: PropTypes.bool.isRequired
};

export default Radium(FieldDetailFormatter);
